/**
 * 提供虚拟滚动功能的组件
 */

import React, {useState, ReactNode, useLayoutEffect, memo, useRef} from 'react';
import {throttle, debounce} from 'lodash-es';
import "./index.scss";
import {ConfigProvider, StatusTip} from "tea-component";
import {useIntl} from "umi";

const {LoadingTip, FoundTip, EmptyTip, ErrorTip} = StatusTip;

interface Props {
  totalHeight?: number; // 所有数据渲染完成后的高度 (这个高度作为滚动元素的高度)
  visibleHeight: number; // 实际渲染的可见的高度
  itemHeight: number; // 每行的高度
  delay?: number;
  renderScrollContent?: (start: number, end: number) => ReactNode[] | Element | Element[];
  onScroll?: (container: Element) => void; // 自定义滚动事件, 组件会内置虚拟滚动计算过程, 但如果用户有其他的滚动事件需要处理, 可以通过onScroll自定义, 包括滚动到底部后需要处理的逻辑. 参数就是挂载滚动事件的容器元素
  container: Element | null; // 挂载滚动事件的容器元素
}

interface ScrollState {
  startIndex: number;
  endIndex: number;
}


function VirtualizedList({
	                         container,
	                         delay,
	                         source = [],
	                         rowHeight,
	                         renderItem,
	                         rowSize,
	                         colSize = 1,
	                         loading,
	                         error,
	                         loadComponent = '',
	                         emptyComponent = '',
	                         errorComponent = '',
	                         onScrollBottom,
	                         containerHeight = "100%",
	                         children
}: Props) {


  const defaultContainerRef = useRef(null);
  const [scrollState, setScrollState] = useState<ScrollState>({
    startIndex: 0,
    endIndex: 0
  });
  useLayoutEffect(() => {
    container = container || defaultContainerRef.current;
    const calculateTranslateY = (scrollTop: number) => {

      const startIndex = Math.max(0, Math.floor(scrollTop / rowHeight) - 1);
      const endIndex = startIndex + rowSize;

      setScrollState(prevState => {
        if (
          prevState.startIndex === startIndex &&
					prevState.endIndex === endIndex
        ) {
          return prevState;
        }
        return {
          startIndex,
          endIndex
        };
      });
    };
    const handleScroll = throttle(() => {
      const scrollTop = container?.scrollTop || 0;
      calculateTranslateY(scrollTop);
      // 滑动到底部时执行函数
      if (container?.scrollTop + container?.clientHeight + rowHeight >= container?.scrollHeight) {
        onScrollBottom?.();
        // // 执行加载函数
        // if ((typeof fetchSource === 'function') && (source?.length < total) && (!loading)) {
        // 	setInsideLoading(true);
        // 	fetchSource(scrollState)?.finally(() => setInsideLoading(false));
        // }
      }
    }, delay);

    container?.addEventListener('scroll', handleScroll);
    calculateTranslateY(container?.scrollTop || 0);

    return () => {
      container?.removeEventListener('scroll', handleScroll);
    };
  }, [onScrollBottom, source, loading]);
  const {locale} = useIntl();
  return (
    <ConfigProvider locale={locale === "en-US" ? "en" : "zh"}>
      <div ref={defaultContainerRef} style={{height: containerHeight}}>
        {children || ""}
        <div
          style={{height: `${Math.ceil(source?.length / colSize) * rowHeight}px`}}
        >
          <div
            style={{transform: `translate(0px, ${scrollState.startIndex * rowHeight}px)`,}}
            className={"scroll-list"}
          >

            {
              source?.slice(scrollState.startIndex * colSize, scrollState.endIndex * colSize)?.map((data: any, index: number) => {
                return renderItem(data, index);
              })

            }
            {
              (loading ? loadComponent : (error ? errorComponent : (source?.length > 0 ? '' : emptyComponent)))
            }

          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default memo(VirtualizedList);

